<template>
  <button
    :class="['drawer-xref-btn', { 'drawer-xref-btn--disabled': disabled }]"
    :disabled="disabled"
    :title="tooltip"
    @click.stop="onClick"
  >
    <v-icon x-small>{{ icon }}</v-icon>
  </button>
</template>

<script>
// Botón inline 24×24 que dispara una cross-reference hacia otra superficie.
// Ver DRAWERS-DESIGN-SPEC §8.4. Se renderiza junto al valor de una fila
// cuando el dato del campo puede alimentar una consulta a otro drawer,
// el mapa o una acción externa.
export default {
  name: 'DrawerCrossRefButton',
  props: {
    icon: { type: String, required: true },
    tooltip: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (!this.disabled) this.$emit('click')
    },
  },
}
</script>

<style scoped>
.drawer-xref-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: transparent;
  border: 1px solid var(--kln-border-accent, rgba(255, 255, 255, 0.3));
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
  flex-shrink: 0;
  padding: 0;
}

.drawer-xref-btn:hover {
  background: var(--kln-accent);
  border-color: var(--kln-accent);
}

.drawer-xref-btn:hover :deep(.v-icon) {
  color: #fff !important;
}

.drawer-xref-btn :deep(.v-icon) {
  color: var(--kln-accent) !important;
  font-size: 14px !important;
}

.drawer-xref-btn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
